<template>
  <div class="$style.feedback_div">
    {{message}}
  </div>
</template>

<script>
export default {
  name: 'Feedback',
  data () {
    return {
      message: 'TODO: Feedback'
    }
  },
  created: function () {
  }
}
</script>

<style module>
  .feedback_div {
    padding: 10px 10px 10px 10px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Feedback.vue